import { useQueryParams } from "@core/routing/use-query-params";
import { tutorialBannerManager, userStatusManager } from "@core/service-container";
import { TutorialBannerType, tutorialBannerTypes } from "@domain/tutorial-banner/tutorial-banner-manager";
import { TutorialBanner } from "@ui/components/tutorial/tutorial-banner";
import { RoutesPath, TabPatientDetails } from "@ui/navigation/routes";
import { useObservable } from "micro-observables";
import React, { useEffect } from "react";
import { useLocation } from "react-router";

const TutorialsRule: Record<
	TutorialBannerType,
	{
		activeScreens: RoutesPath[];
		activeTab?: string;
	}
> = {
	[TutorialBannerType.MONITOR_PATIENT_PROGRAM]: {
		activeScreens: [RoutesPath.PatientDetails],
		activeTab: TabPatientDetails.PROGRESS_TAB,
	},
	[TutorialBannerType.INVITE_TO_HCT]: {
		activeScreens: [RoutesPath.PatientDetails],
		activeTab: TabPatientDetails.HEALTHCARE_TAB,
	},
};

export const TutorialBannerDisplayer: React.FC = () => {
	const banners = useObservable(tutorialBannerManager.displayedBanners);
	const location = useLocation();
	const { active } = useQueryParams<RoutesPath.PatientDetails>();
	const ptStatus = useObservable(userStatusManager.ptRegistrationStatus);

	useEffect(() => {
		tutorialBannerManager.hideBanners();
		const shouldDisplayBanner = (rules: { activeScreens: RoutesPath[]; activeTab?: string }) =>
			rules.activeScreens.some(path =>
				path.includes(":") ? location.pathname.startsWith(path.split(":")[0]) : location.pathname === path,
			) && (rules.activeTab ?? active) === active;

		tutorialBannerTypes.forEach(type => {
			if (shouldDisplayBanner(TutorialsRule[type])) {
				tutorialBannerManager.displayBanner(type);
			}
		});
	}, [active, location, ptStatus]);

	return (
		<>
			{banners.map(bannerType => (
				<TutorialBanner key={bannerType} bannerType={bannerType} />
			))}
		</>
	);
};
